module.exports = "../../../../platform/assets/pageMainIcon/youth_danjuweihulei5.svg";